/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Import_Stat_ErrorsInputs */

const cs_import_stat_errors = /** @type {(inputs: Import_Stat_ErrorsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chyby: ${i?.count}`)
};

const en_import_stat_errors = /** @type {(inputs: Import_Stat_ErrorsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Errors: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Errors: {count}" |
*
* @param {Import_Stat_ErrorsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_stat_errors = /** @type {((inputs: Import_Stat_ErrorsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Stat_ErrorsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_stat_errors(inputs)
	return cs_import_stat_errors(inputs)
});